import mapboxgl from 'mapbox-gl';

if ($('.acf-map')) {
    const marker = $('.marker');

    if(marker.attr('data-lng')) {
        var markerPosition = new mapboxgl.LngLat( marker.attr( 'data-lng' ), marker.attr( 'data-lat' ) );
        mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsa3J4dmp1eDFwZ2ozam9jcW43NjZ6Z24ifQ.vAENY4zNV2-7DHDSmOg_BQ';

        var map = new mapboxgl.Map({
            container: 'acf-map',
            style: 'mapbox://styles/blackdesk/clkryncsh00q501pheszc9veu',
            center: markerPosition,
            maxZoom: 18,
            zoom: 14,
        });

        var el = document.createElement( 'div' );
        el.className = 'marker';
        el.style.backgroundImage = 'url(/wp-content/uploads/2023/09/traasvloeren-pinner-2.svg)';
        el.style.width = '35px';
        el.style.height = '50px';
        el.style.marginTop = '-25px';
        el.backgroundSize = 'cover';

        new mapboxgl.Marker(el)
        .setLngLat( markerPosition )
        .addTo( map );

        map.on( 'load', function() {
            map.resize();
        });
    }
}
